import { ActionIcon, Menu, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { LANGUAGES, normaliseLanguage, setLanguage } from '../i18n';

/**
 * Serbian shows the Montenegrin flag and is labelled "Srpski", which is how the language is
 * named and written in Nikšić.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const active = normaliseLanguage(i18n.language);
  const current = LANGUAGES.find((language) => language.key === active) ?? LANGUAGES[0];

  return (
    <Menu position="bottom-end" withinPortal shadow="md">
      <Menu.Target>
        <Tooltip label={t('common.language')}>
          <ActionIcon variant="subtle" color="gray" size="lg" aria-label={t('common.language')}>
            <Text fz={18} lh={1}>
              {current.flag}
            </Text>
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        {LANGUAGES.map((language) => (
          <Menu.Item
            key={language.key}
            leftSection={<Text fz={16}>{language.flag}</Text>}
            onClick={() => void setLanguage(language.key)}
            fw={language.key === active ? 600 : 400}
          >
            {language.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
